import { render, staticRenderFns } from "./ClassInvoice.vue?vue&type=template&id=30d4c6e1&scoped=true"
import script from "./ClassInvoice.vue?vue&type=script&lang=js"
export * from "./ClassInvoice.vue?vue&type=script&lang=js"
import style0 from "./ClassInvoice.vue?vue&type=style&index=0&id=30d4c6e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d4c6e1",
  null
  
)

export default component.exports